import { CalendarCheck } from 'lucide-react';

/**
 * Small indicator icon showing that an issue has calendar events
 */
function CalendarIndicator({ events, className = '' }) {
  if (!events || events.length === 0) return null;
  
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('it-IT', {
      day: '2-digit',
      month: 'short'
    });
  };

  const nextEvent = events[0]; // Events are sorted by date
  const tooltip = events.length === 1 
    ? `Calendarizzato: ${formatDate(nextEvent.event_date)}`
    : `${events.length} eventi calendario`;

  return (
    <span 
      className={`inline-flex items-center ${className}`}
      title={tooltip}
    >
      <CalendarCheck className="h-3.5 w-3.5 text-[rgb(59,130,246)]" />
    </span>
  );
}

export default CalendarIndicator;
